import { render } from "./NewsThumbsup.vue?vue&type=template&id=71625b9c&scoped=true"
import script from "./NewsThumbsup.vue?vue&type=script&lang=js"
export * from "./NewsThumbsup.vue?vue&type=script&lang=js"

import "./NewsThumbsup.vue?vue&type=style&index=0&id=71625b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71625b9c"]])

export default __exports__